import React, { ReactNode } from 'react';
import { useAuth as useCanonicalAuth } from '../../contexts/AuthContext';

/**
 * R6.3 compatibility bridge.
 *
 * The former SOVERDI clone carried its own demo identity/session. That is no
 * longer acceptable now that the clone reads real Agri Safe data. Every clone
 * component importing this module now consumes the single canonical Agri Safe
 * Cognito/AuthProvider mounted by App.tsx.
 *
 * No token is copied, persisted or transformed here. The wrapper only keeps the
 * historical import surface stable while the UI clone is progressively folded
 * into the main application.
 */
export const useAuth = useCanonicalAuth;

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * Kept as a no-op compatibility wrapper so existing clone composition does not
 * need a risky broad rewrite. Authentication is provided by App.tsx.
 */
export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => <>{children}</>;
